import { FC } from "react";
import { Box } from "../../../../../components";
import AddDocumentTagModalForm from "./add-document-tags-modal-form";
import { DocumentTagTable } from "./document-tags-table";
import { withProcedureWraper } from "../../..";

export const documentTagsBox: FC = withProcedureWraper(() => {
  return (
    <div className="ProcedureTrainingPlanPage">
      <div className="pd15">
        <div className="d-flex p-3 justify-content-center">
          <h3>
            <br />
          </h3>
        </div>
        <Box
          title="Quản lý danh mục tài liệu"
          className="min-h-[553px] w-full h-full overflow-auto p-2"
          titleRight={<AddDocumentTagModalForm />}
        >
          <DocumentTagTable />
        </Box>
      </div>
    </div>
  );
});
